import { useMemo, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

export const useSearchParams = <T extends string>() => {
  const { search } = useLocation();
  const history = useHistory();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  // TODO: refactor -- usage of these is verbose
  const getSearchParam = useCallback(
    (...keys: T[]) => {
      const values = Array.prototype.map.call(
        keys,
        searchParams.get,
        searchParams,
      );
      return keys.length === 1 ? (values[0] as string) : (values as string[]);
    },
    [searchParams],
  );

  // For params that are arrays
  const getArraySearchParams = useCallback(
    (...keys: T[]) =>
      Array.prototype.map.call(
        keys,
        searchParams.getAll,
        searchParams,
      ) as string[][],
    [searchParams],
  );

  const deleteSearchParam = (...params: T[]) => {
    Array.prototype.forEach.call(
      params,
      (param: T) => searchParams.delete(param),
      searchParams,
    );
    history.replace({ search: searchParams.toString() });
  };

  return {
    searchParams,
    getSearchParam,
    getArraySearchParams,
    deleteSearchParam,
  };
};
